import $ from 'jquery'

class AboutBiz {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		$(document).ready(function () {
			myObj.AboutBizFunction()
		})
	}

	//? 3. methods (functions)
	AboutBizFunction() {
		console.log('Hello bix')

		// overlayTwo
		// overlayThree

		let mobileSettins = { scale: 1, x: 400, y: -200 }
		let DesktopSettings = { scale: 1.5, x: 250 }
		let actualSettings = { scale: 1, x: 450, y: -200 }

		if (window.innerWidth > 992) {
			actualSettings = DesktopSettings
		} else {
			actualSettings = mobileSettins
		}

		let myTimeline = new TimelineLite()
		myTimeline
			.add('start', 0)
			.add('main', 2.5)
			.add('frameOne', 3.5)

			// .from('.mainImageOne', 2, { scale: 1.1, ease: 'expo.out' }, 'start')

			.staggerFromTo(
				'.PurpleOV',
				0.3,
				{
					clip: 'rect(0px,2200px,0px,0px)',

					opacity: 0.5,
				},
				{
					clip: 'rect(0px,2200px,1090px,0px)',

					opacity: 1,
				},
				0.2,
				'start'
			)
			.staggerFrom(
				'.fade-in-anime',
				0.5,
				{ opacity: 0, delay: 0.2 },
				0.2,
				'start'
			)
			.fromTo(
				'.lineOne',
				1,
				{
					clip: 'rect(0px,0px,1090px,1920px)',
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',

					delay: 0.5,
				},
				'start'
			)
			.staggerFromTo(
				'.lineTwo',
				0.5,
				{
					clip: 'rect(0px,1920px,0px,0px)',
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',
					delay: 0.8,
				},
				0.2,
				'start'
			)
			.to('.mainImageOne', 1, { opacity: 0.1, delay: 1 }, 'start')
			.from('.vinyet', 0.2, { opacity: 0, delay: 1 }, 'start')
			// .to('.imgCanves', 1, { y: -100, delay: 1 }, 'start')
			.from(
				'.content-box-three',
				1,
				{ opacity: 0, y: 200, delay: 1 },
				'start'
			)

			.to('.content-box-three', 0.3, { opacity: 0, y: 200 }, 'frameOne')
			.to('.fOneHide', 0.5, { opacity: 0 }, 'frameOne')
			.to('.imgCanves', 1, actualSettings, 'frameOne')
			// .to(
			// 	'.mainLine',
			// 	0,
			// 	{
			// 		clip: 'rect(0px,0px,1090px,1920px)',
			// 		opacity: 0,
			// 	},
			// 	'frameOne'
			// )
			.to(
				'.customerOne',
				0,
				{
					clip: 'rect(0px,1920px,1090px,0px)',
					opacity: 0,
				},
				'frameOne'
			)
			.fromTo(
				'.customerOne',
				0.3,
				{
					clip: 'rect(0px,1920px,0px,0px)',

					opacity: 0.5,
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',
					opacity: 1,
					delay: 1,
				},
				'frameOne'
			)

			.from('.mainModal', 1, { opacity: 0, delay: 1.3 }, 'frameOne')
			// .to(
			// 	'.mainLine',
			// 	0,
			// 	{
			// 		clip: 'rect(0px,1920px,1090px,0px)',
			// 		opacity: 1,
			// 		delay: 0.1,
			// 	},
			// 	'frameOne'
			// )
			.fromTo(
				'.mainLine',
				1,
				{
					clip: 'rect(0px,0px,1090px,1920px)',
					opacity: 0,
				},
				{
					clip: 'rect(0px,1920px,1090px,0px)',
					opacity: 1,
					delay: 1.5,
				},
				'frameOne'
			)
			.from(
				'.content-box-one',
				1,
				{ opacity: 0, x: 300, delay: 1.5 },
				'frameOne'
			)
			.to('.content-box-one', 1, { opacity: 1 })

		// init controller
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#aboutBiz',
			offset: window.innerHeight / 2,
			duration: window.innerHeight * 2.5,
		})
			.setTween(myTimeline) // trigger a TweenMax.to tween
			// .addIndicators({ name: '1 (duration: 0)' })
			.setPin('#aboutBiz')
			.addTo(controller)
	}
}

export default AboutBiz
